import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import DashboardPopover from '../../../components/Popover';
import RiskWidget from '../../components/riskWidget';
import { DashboardService } from '../../../../../services';
import moment from 'moment';

const type = 'DEFAULT';

const SupplyChainRisk = ({ selectedProject, assessed, }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);

  const _fetch = async () => {
    setLoading(true);
    setData(null);

    try {
      const res = await DashboardService.getPmeProject({
        widget: 'supplyChainRisk',
      })

      if (res?.data?.supplyChainRisk) {
        const { supplyChainRisk } = res.data;
        const mappedData = Object.keys(supplyChainRisk).reduce((all, key) => {
          const date = moment(key, 'yyyy-MM-dd');
          const month = date.get('month') + 1;
          const year = date.get('year');

          if (!all[year]) {
            all[year] = {
              [month]: [supplyChainRisk[key]],
            };

          } else {
            if (Array.isArray(all[year][month])) {
              all[year][month].push(supplyChainRisk[key]);
            } else {
              all[year][month] = [supplyChainRisk[key]];
            }
          }

          return all;
        }, {});

        setData(Object.keys(mappedData).reduce((all, key) => {
          const _val = Object.keys(mappedData[key]).reduce((_all, _key) => {
            const scores = mappedData[key][_key];
            const sum = scores.reduce((all, val) => all + val, 0);
            _all[_key] = sum / scores.length / 20;
            return _all;
          }, {});

          all[key] = _val;
          return all;
        }, {}));
      }
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!data) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [data]);

  useEffect(() => {
    _fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedProject]);

  const selectOptions = useMemo(() => {
    if (data) {
      return Object.keys(data).sort((a, b) => b - a).map((d) => ({
        value: d,
        label: d,
      }));
    }
    return [];
  }, [data]);

  const metrics = useMemo(() => {
    if (data && data.data && typeof data.participantsAssessed === 'number') {
      const values = Object.values(data.data);
      return [
        {
          key: 'sitesEvaluated',
          label: 'Participants Assessed',
          value: data.participantsAssessed || 0,
        },
        {
          key: 'riskScore',
          label: t('Assessment Score'),
          value: values[values.length - 1] || 0,
          type: 'riskScoreSupplyChain',
        },
      ]
    }
    return [];
  }, [data, t]);

  return (
    <RiskWidget
      t={t}
      title={t('Supply Chain Risk')}
      selectOptions={selectOptions}
      metricsItems={metrics}
      data={data ? (data || {}) : {}}
      loading={loading}
      headerLabel="Included Participants"
      headerValue={Number(assessed || 0).toLocaleString('en-us')}
      type={type}
      tooltip={(
        <DashboardPopover
          title={t('Supply Chain Risk')}
          body={t('Average counterparty assessment score of all selected supply chain participants.')}
        />
      )}
    />
  );
};

export default SupplyChainRisk;
